// extracted by mini-css-extract-plugin
export default {"Header_Cnt":"COM001F1_Header_Cnt__VPVMT","portalLogo":"COM001F1_portalLogo__lKyzb","infoBox":"COM001F1_infoBox__X-29N"};